import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { useState } from "react";
import {
  genElDate,
  genElDateObject,
  genElObject,
} from "../../../components/utils/EditorDialogElementGenerator";
import { format } from "date-fns";
import KendaraanSelectorDialog from "../../../dialogs/selectors/KendaraanSelectorDialog";

const filterModeOptions = [
  { icon: "pi pi-calendar", value: "By Tanggal" },
  { icon: "pi pi-truck", value: "By Kendaraan" },
];

const ServiceKendaraanFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const [filterMode, setFilterMode] = useState("By Tanggal"); // by_tanggal | by_kendaraan
  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);

  // handle ui event section
  const handleOnConfirmKendaraan = (event, datas) => {
    if (datas && datas.length > 0) {
      const kendaraan = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_kendaraan: kendaraan,
        kendaraan_id: kendaraan.id,
      }));
      setShowKendaraanSelector(false);
    }
  };

  // custom ui section

  const filterModeTemplate = (option) => {
    return <i className={option.icon}></i>;
  };

  const elTanggal = genElDateObject({
    field: "tanggal",
    name: "Tanggal Service",
    value: filterValue.tanggal,
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd MM yy",
  });

  const elTanggalDari = genElDateObject({
    field: "tanggal_dari",
    name: "Tanggal Service (Dari)",
    value: filterValue.tanggal_dari,
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd MM yy",
  });

  const elTanggalSampai = genElDateObject({
    field: "tanggal_sampai",
    name: "Tanggal Service (Sampai)",
    value: filterValue.tanggal_sampai,
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd MM yy",
  });

  const elNomorPolisi = genElObject({
    field: "kendaraan_id",
    name: "No Polisi",
    value: filterValue.data_kendaraan
      ? filterValue.data_kendaraan.nomor_polisi
      : "",
    onClick: () => {
      setShowKendaraanSelector(true);
    },
  });

  return (
    <div className="row-between-end gap-4 w-full flex-wrap">
      <KendaraanSelectorDialog
        title={"Pilih Kendaraan"}
        visible={showKendaraanSelector}
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />

      {/* filter component section */}
      <div className="row-start-end gap-4 w-full sm:w-auto flex-wrap">
        <SelectButton
          value={filterMode}
          options={filterModeOptions}
          itemTemplate={filterModeTemplate}
          optionLabel="value"
          onChange={(e) => {
            if (e.value === "By Tanggal") {
              setFilterValue((prevData) => ({
                ...prevData,
                mode: "By Tanggal",
              }));
            } else if (e.value === "By Kendaraan") {
              setFilterValue((prevData) => ({
                ...prevData,
                mode: "By Kendaraan",
              }));
            }
            setFilterMode(e.value);
          }}
        />

        {filterMode === "By Tanggal" && (
          <div className="row-start-start flex-wrap">
            {/* filter tanggal */}
            <div className="row-start-start w-full sm:w-[14rem]">
              {elTanggal}
            </div>
          </div>
        )}
        {filterMode === "By Kendaraan" && (
          <div className="row-start-start gap-4 flex-wrap">
            {/* filter tanggal dari */}
            <div className="row-start-start w-full sm:w-[14rem]">
              {elTanggalDari}
            </div>

            {/* filter tanggal sampai */}
            <div className="row-start-start w-full sm:w-[14rem]">
              {elTanggalSampai}
            </div>

            {/* filter Kendaraan */}
            <div className="col-start-start w-full sm:w-[11rem]">
              {elNomorPolisi}
            </div>
          </div>
        )}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default ServiceKendaraanFilter;
